export default {
    setAnalytics3d: (state, param) => {
        const {payload} = param;
        return state.data = payload;
    },
    clearFilters: (state) => {
        state.queryParams = {perPage: 25, page: 1, sort: 'createdAt', sortDirection:'DESC', orderStatusId: null, createdAt_max: null}
    }
}
